module.exports = new __parcel__URL__("stamp02.d516d918.png").toString();